import React from 'react';
import LwtTable from 'components/@common/Table/LwtTable';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import getSingleModuleColumns from './SingleModuleColumns';
import { upperCase } from 'lodash';
import { isAllSelected } from 'components/ReportsModule/components/KeyboardingReport/keyboarding-report-util';
import getColumns from 'components/ReportsModule/components/KeyboardingReport/AccessmentAcceleratorComponents/allModulesTableCol';

type Props = {
  selectedModule: any;
  data: any[];
};

const ActivityTable: React.FC<Props> = ({ selectedModule, data }) => {
  const classes = useStyles();
  const { t } = useTranslation(['Reports', 'ReportsHelpCommon', 'ReportsHelpTableColumns']);
  const tUpper = (val: any) => upperCase(t(val));
  const columns = isAllSelected(selectedModule)
    ? getColumns(tUpper)
    : getSingleModuleColumns(tUpper);

  return <LwtTable columns={columns} data={data} classes={{ row: () => classes.tableRow }} />;
};

const useStyles = makeStyles(() => ({
  tableRow: {
    background: '#FCFCFC'
  }
}));

export default ActivityTable;
